<template>
  <div class="home">
    <TransactionList />
  </div>
</template>

<script>
// @ is an alias to /src
import TransactionList from "@/components/TransactionList.vue";

export default {
  name: "home",
  components: {
    TransactionList
  }
};
</script>
